import { useQuery } from '@tanstack/react-query';
import { fetchUser } from '../../../api';

export function useApiUser(id: string, params?: Record<string, any>) {
  return useQuery({
    queryKey: ['users', id, params],
    queryFn: () => fetchUser(id, params),
  });
}
